import _Vue, { PluginObject } from 'vue';

declare module 'vue/types/vue' {
  interface Vue {
    $dialog: {
      show(dialogContent: DialogContent): DialogInstance;
    };
  }
}

interface DialogContent {
  title?: string;
  buttons?: DialogButton[];
}

interface DialogButton {
  label: string;
  handler?(): void;
}

interface DialogPluginObject extends PluginObject<_Vue> {
  EventBus: _Vue | undefined;
  dialogs: DialogInstance[];
}

export class DialogInstance {
  public events: _Vue = new _Vue();

  public title: string;

  public buttons: DialogButton[];

  constructor(dialogContent: DialogContent) {
    this.title = dialogContent.title || '';
    this.buttons = dialogContent.buttons || [];
  }

  public dismiss() {
    this.events.$emit('dismiss');
  }
}

const DialogPlugin: DialogPluginObject = {
  EventBus: undefined,
  dialogs: [],
  install: (Vue: typeof _Vue) => {
    DialogPlugin.EventBus = new Vue();
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$dialog = {
      show(dialogContent: DialogContent) {
        const dialog = new DialogInstance(dialogContent);
        dialog.events.$once('dismiss', () => {
          DialogPlugin.dialogs = DialogPlugin.dialogs.filter(
            (dialogEntry: DialogInstance) => dialogEntry !== dialog
          );
          if (DialogPlugin.EventBus) {
            DialogPlugin.EventBus.$emit('dialogs', DialogPlugin.dialogs);
          }
        });
        DialogPlugin.dialogs.unshift(dialog);
        if (DialogPlugin.EventBus) {
          DialogPlugin.EventBus.$emit('dialogs', DialogPlugin.dialogs);
        }
        return dialog;
      },
    };
  },
};

export default DialogPlugin;
